import BaseAtomView from 'views/atoms/base-atom-view';
import ImageAtomTemplate from './templates/image-atom';
import EF from 'ef/ef';
import LocaleService from 'services/loader-handler-services/locale-service';
const ImageAtomView = BaseAtomView.extend({
  template: ImageAtomTemplate,
  initialize: function () {
    if (this.model.get('path').search('custom://') === 0) {
      const customImage = EF.customizations.getByKeyAndSlug(
        'image-content-customization',
        this.model.get('path').replace('custom://', '')
      );
      const customPath = customImage.url || customImage.path;
      if (!customPath) {
        console.warn(`No customization found for ${this.model.get('path')}`);
        return;
      }
      this.model.set('path', customPath);
    }
    if (this.model.get('path').search('locale://') === 0) {
      const localizedPath = LocaleService.t(this.model.get('path').replace('locale://', ''));
      if (!localizedPath) {
        console.warn(`No localization found for ${this.model.get('path')}`);
      }
      this.model.set('path', localizedPath);
    }
  },
});

export default ImageAtomView;
